module.exports = __webpack_public_path__ + "static/image02a@2x-b7e3e1f90eed3e04992cce6e69870616.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/monzo/image02a@2x.jpg
// module id = 406
// module chunks = 3627797113349 20562973939449 33019919093843